/**
 * Gerador de imagem-placeholder em SVG (data URI).
 *
 * Existe só para o modo mock: mantém a UI populada sem depender de rede nem de
 * assets versionados. Quando a API real entregar URLs de imagem, nada aqui é
 * usado.
 */

const PALETTE = [
  ['#e9f5ee', '#00a650'],
  ['#fdf3dd', '#b98900'],
  ['#eef1f7', '#4a5b7a'],
  ['#fbeceb', '#c0463c'],
  ['#eef7fa', '#2b7f95'],
  ['#f3eefa', '#6b4a95'],
] as const

/** Hash estável para que o mesmo produto receba sempre a mesma cor. */
function hash(seed: string): number {
  let h = 0
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) | 0
  return Math.abs(h)
}

export function placeholderImage(seed: string, label?: string): string {
  const [bg, fg] = PALETTE[hash(seed) % PALETTE.length]
  const initials = (label ?? seed)
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase() ?? '')
    .join('')

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">
  <rect width="400" height="400" fill="${bg}"/>
  <g fill="none" stroke="${fg}" stroke-width="10" stroke-linejoin="round" stroke-linecap="round" opacity="0.35">
    <path d="M200 96 314 154v122L200 334 86 276V154z"/>
    <path d="M86 154l114 58 114-58M200 212v122"/>
  </g>
  <text x="200" y="378" text-anchor="middle" font-family="Inter, Arial, sans-serif"
        font-size="34" font-weight="700" fill="${fg}" opacity="0.55">${initials}</text>
</svg>`

  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`
}

/** Banner largo do carrossel da home. */
export function placeholderBanner(title: string, subtitle: string): string {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 380">
  <defs>
    <linearGradient id="g" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#00a650"/>
      <stop offset="62%" stop-color="#12b45e"/>
      <stop offset="100%" stop-color="#ededed"/>
    </linearGradient>
  </defs>
  <rect width="1440" height="380" fill="url(#g)"/>
  <g fill="#ffffff" opacity="0.16">
    <circle cx="180" cy="90" r="46"/><circle cx="1290" cy="120" r="62"/>
    <rect x="1080" y="240" width="90" height="60" rx="8"/>
    <rect x="250" y="250" width="70" height="46" rx="8"/>
  </g>
  <g fill="#ffc107" opacity="0.9">
    <rect x="420" y="40" width="14" height="26" rx="3" transform="rotate(24 427 53)"/>
    <rect x="980" y="70" width="14" height="26" rx="3" transform="rotate(-18 987 83)"/>
    <rect x="700" y="300" width="14" height="26" rx="3" transform="rotate(40 707 313)"/>
  </g>
  <text x="720" y="170" text-anchor="middle" font-family="Inter, Arial, sans-serif"
        font-size="76" font-weight="800" fill="#ffffff" letter-spacing="2">${title}</text>
  <text x="720" y="232" text-anchor="middle" font-family="Inter, Arial, sans-serif"
        font-size="30" font-weight="600" fill="#ffffff" opacity="0.92">${subtitle}</text>
</svg>`

  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`
}
